import React from "react";
import B2BenefitsHead from "./B2BenefitsHead";
import B2BenefitsMain from "./B2BenefitsMain";

const B2Benefits = () => {
  return (
    <div className="lvlBenefitsContainer">
      <B2BenefitsHead />
      <B2BenefitsMain />
    </div>
  );
};

export default B2Benefits;
